import React from 'react';
import rollin from '../../assets/img/rollin.gif';

import images from '../../services/images';
import { ProgressSpinner } from 'primereact/progressspinner';

const PreLoader = ({ isLoading }) => {

    if (!isLoading) {
        return "";
    }

    return (
        <div style={{ position: 'absolute', zIndex: 1099, top: "-60px", left: 0, bottom: 0, right: 0, background:'rgba(255, 255, 255, 0.98)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
            <div>
                <ProgressSpinner style={{maxWidth: '80px', }} strokeWidth={3}  />
            </div>
            <img src={images.etyel_one_logo} alt="Logo" width={300} />
        </div>
    );
}

export default PreLoader;